import TableList from "@components/templates/tablelist";
import {
    HttpProdMappingList,
    HttpDeleteProdMappingOne,
    HttpAllInsuranceServiceList
} from "@/service/credit";
import { mapGetters } from "vuex";
import compUpdate from "./update";
export default {
    mixins: [TableList],
    components: {
        compUpdate
    },
    data () {
        return {
            isMixin: true,
            Tools: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90
            },
            Plugins: { show: true },
            insuranceServiceList: [],
        };
    },
    created () {
        HttpAllInsuranceServiceList().then(res => {
            this.insuranceServiceList = res.data.filter(item => {
                return item.status == 0
            })
        })
    },
    methods: {
        ajaxRequest: HttpProdMappingList,
        handleOperates (params = "", type, batch) {
            switch (type) {
                case "query":
                    this.operate = {
                        show: true,
                        activeid: params,
                        title: "查看",
                        component: "compUpdate",
                        width: 1100,
                        showFooter: false,
                        querytype: 'query'
                    };
                    break;
                case "edit":
                    var url = this.$router.resolve({
                        name: "rulesProdmappingsUpdate",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "add":
                    this.$router.push({
                        name: 'rulesProdmappingsUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "noactive":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: "删除",
                        ajaxRequest: HttpDeleteProdMappingOne
                    };
                    break;
            }
        },
        getOperateNodeMap (row) {
            const { id, status } = row;
            return [
                {
                    label: "查看详情",
                    params: id,
                    show: true,
                    operate: "query"
                },
                {
                    label: "编辑",
                    params: id,
                    show: true,
                    operate: "edit"
                },
                {
                    label: "删除",
                    params: id,
                    show: true,
                    operate: "noactive"
                },
            ];
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getInsuranceList']),
        insuranceList () {
            return this.getInsuranceList.filter(item => {
                return item.attach.status === 0
            })
        },
        ToolsData () {
            return [
                {
                    label: "添加",
                    operate: "add",
                    theme: "primary"
                }
            ];
        },
        SearchsData () {
            return [
                {
                    label: "保险产品",
                    key: 'EQ_serviceId',
                    tag: 'Select',
                    options: this.insuranceList,
                    show: true,
                },
                {
                    label: "保险服务商",
                    key: 'EQ_serviceProviderId',
                    tag: 'Select',
                    options: this.insuranceServiceList.map(item => {
                        return {
                            value: item.id,
                            label: item.providerName + '(' + item.providerCode + ')',
                        }
                    }),
                    show: true,
                },
                {
                    label: "状态",
                    key: 'EQ_status',
                    tag: 'Select',
                    options: [
                        { value: 0, label: '启用' },
                        { value: 1, label: '禁用' },
                    ],
                },
                {
                    label: "创建日期",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    show: true,
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                    style: "width:250px",
                },
            ];
        },
        columns () {
            return [
                {
                    title: "操作",
                    maxWidth: 90,
                    render: this.getOperateNodes
                },
                {
                    title: "保险产品编码",
                    render: (h, { row }) => {
                        let code = this.insuranceList.filter(item => {
                            return item.value === row.serviceId
                        })[0]
                        return <span>{code.attach.serviceCode}</span>
                    }
                },
                {
                    title: "保险产品名称",
                    render: (h, { row }) => this.findRenderLabel(this.insuranceList, row.serviceId)
                },
                {
                    title: "保险服务商编码",
                    render: (h, { row }) => {
                        let code = this.insuranceServiceList.filter(item => {
                            return item.id === row.serviceProviderId
                        })[0]
                        return <span>{code.providerCode}</span>
                    }
                },
                {
                    title: "保险服务商名称",
                    render: (h, { row }) => {
                        let code = this.insuranceServiceList.filter(item => {
                            return item.id === row.serviceProviderId
                        })[0]
                        return <span>{code.providerName}({code.providerCode})</span>
                    }
                },
                {
                    title: "保险服务商产品编码",
                    key: "providerServiceCode"
                },
                {
                    title: "创建日期",
                    key: "createdAt",
                    sortable: true
                },
            ];
        }
    }
};
